import localeAntd from 'ant-design-vue/lib/locale-provider/en_US'

const messages = {
  topBar: {
    issuesHistory: 'Issues History',
    projectManagement: 'Project Management',
    typeToSearch: 'Search...',
    findPages: 'Find pages...',
    actions: 'Actions',
    status: 'Status',
    profileMenu: {
      hello: 'Hello',
      subscriptionPlan: 'Subscription Plan',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      editProfile: 'Edit Profile',
      logout: 'Logout',
    },
  },
  pricing: {
    basic: {
      feature1: '1,000 exam questions with answers and rationale',
      feature2: 'Exam preparation dashboard',
      feature3: 'Progress tracking',
      feature4: 'Basic customer support',
    },
    pro: {
      feature1: '2,000 exam questions with answers and rationale',
      feature2: 'Exam preparation dashboard',
      feature3: 'Progress tracking',
      feature4: 'Premium customer support',
    },
    unlimited: {
      feature1: 'Over 3,000 exam questions with answers and rationale',
      feature2: 'Exam preparation dashboard',
      feature3: 'Progress tracking',
      feature4: 'Premium customer support',
      feature5: 'Early access and exclusive discounts on nursing-themed merchandise',
    },
  },
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
